import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

class ReCaptcha extends Component {
  constructor(props) {
    super(props);
    this.state = {
      captchaValue: null,
    };
  }

  handleCaptchaChange = (value) => {
    this.setState({ captchaValue: value });
    this.props.onChange(value); // Call the parent function with the new value
  };

  render() {
    return (
      <div>
        <ReCAPTCHA
          sitekey="6LccXWAqAAAAADnLq4wsw4-ufK_8knRNydcSVWtT"
          onChange={this.handleCaptchaChange}
        />
      </div>
    );
  }
}

export default ReCaptcha;
